export class EventHelper {
  public static dispatch(elementOrWindow: Element | Window, eventType: string, detail: any = {}) {
    const evt = new CustomEvent(eventType, { bubbles: true, detail });
    elementOrWindow.dispatchEvent(
      evt
    );
  }
}
